export const page7 = {
  "name": "page7",
  "title": "Nutrition",
  "elements": [
    {
      "type": "rating",
      "name": "fast_food_consumption",
      "title": "How often do you consume fast food, unhealthy snacks or sweetened drinks?",
      "isRequired": true,
      "autoGenerate": false,
      "rateValues": [
        {
          "value": 1,
          "text": "Never"
        },
        {
          "value": 2,
          "text": "Rarely"
        },
        {
          "value": 3,
          "text": "Sometimes"
        },
        {
          "value": 4,
          "text": "Often"
        },
        {
          "value": 5,
          "text": "Daily"
        }
      ]
    },
    {
      "type": "rating",
      "name": "fruits_and_vegetables",
      "title": "How many portions of fruits and vegetables do you eat a day?",
      "description": "1 portion fits in the palm of your hand and does not include fruit juices",
      "isRequired": true
    },
    {
      "type": "rating",
      "name": "nutrition_rating",
      "title": "How would you rate your current nutrition?",
      "rateType": "stars",
      "isRequired": true
    }
  ]
};